import { openFacebookShare, openTwitterShare, analyticsPushFunc, openTelegramShare } from "../../../../widgetsUtils"
import { MailShareButton } from "../../../../siteWidgets/socialShareButtons/mail/mailShareButton"
import { WhatsAppShareButton } from "../../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton"
import { FrontCopyButton } from "../../../../commonComponents/inline/frontCopyButton/frontCopyButton"
require("./ynet_pplus_magazine_site_siteArticleSocialShare1280.less")

type ShowBtnsType = "fb" | "tw" | "wa" | "tg" | "mailto" | "print" | "tb" | "copyLink"

interface SiteArticleSocialShare1280Props {
    language?: string
    className?: string
    analyticsTitle?: string
    showBtns?: ShowBtnsType[]
    analyticsCategory?: string
}

export class SiteArticleSocialShare1280 extends React.Component<SiteArticleSocialShare1280Props, {}> {
    static siteScriptName = "SiteArticleSocialShare1280"

    private handleShareBtnClicked = (button: string) => {
        const { analyticsTitle, analyticsCategory = "Article Top" } = this.props;

        if (typeof window !== "undefined") {
            const current_url = window.location.href;

            switch (button) {
                case "fb":
                    openFacebookShare(current_url, "", () => analyticsPushFunc("Facebook", analyticsCategory, analyticsTitle), analyticsCategory)
                    break;

                case "tw":
                    openTwitterShare(current_url, () => analyticsPushFunc("Twitter", analyticsCategory, analyticsTitle), analyticsCategory)
                    break;

                case "mailto":
                    MailShareButton.openMailShare(document.title, current_url, "he", () => analyticsPushFunc("Mail", analyticsCategory, analyticsTitle), analyticsCategory)
                    break;

                case "wa":
                    WhatsAppShareButton.openWhatsAppShare(current_url, () => analyticsPushFunc("Whatsapp", analyticsCategory, analyticsTitle), analyticsCategory)
                    break;

                case "tg":
                    openTelegramShare(current_url, () => analyticsPushFunc("Telegram", analyticsCategory, analyticsTitle), analyticsCategory)
                    break;

                case "print":
                    window.print();
                    break;

                case "tb":
                    const elementToScroll = document.querySelector('#SiteArticleComments')
                    const commentsPopUp = document.querySelector('.ArticleCommentsPopup')
                    if (elementToScroll && !commentsPopUp) {
                        setTimeout(() => {
                            elementToScroll.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }, 0)
                    }
                    if (commentsPopUp) {
                        window.handleCommentsPopupVisability && window.handleCommentsPopupVisability();
                    }
                    break;
            }
        }
    }

    private shouldShow = (btnName: ShowBtnsType): boolean => {
        const { showBtns = [] } = this.props;
        return showBtns.includes(btnName);
    }

    render() {
        const { analyticsTitle, language, className = "" } = this.props;
        const langToUse = language ? language.slice(0, 2) : undefined;
        let textMail = "שלחו כתבה";
        let textTw = "שיתוף בטוויטר";
        let textFb = "שיתוף בפייסבוק";
        let textWa = "שיתוף בואטסאפ";
        let textTg = "שיתוף בטלגרם";
        let textPrint = "הדפס"
        let textCp = "העתק קישור"
        let textCpPopUp = "הקישור הועתק ללוח"
        let textNewPost = "פרסם תגובה חדשה"

        if (langToUse === "en") {
            textMail = "Send Email";
            textTw = "Twitter";
            textFb = "Facebook";
            textWa = "Whatsapp";
            textTg = "Telegram";
            textPrint = "Print"
            textCp = "Copy Link"
            textCpPopUp = "Link copied to clipboard"
            textNewPost = "New Post"
        } else if (langToUse === "ru") {
            textMail = "Эл. почта";
            textTw = "Твиттер";
            textFb = "Фейсбук";
            textWa = "Ватсап";
            textTg = "Телеграм";
            textPrint = "Печать"
            textCp = "Скопировать ссылку"
            textCpPopUp = "Ссылка скопирована в буфер обмена"
            textNewPost = "Новый пост"
        } else if (langToUse === "ar") {
            textMail = "ارسل بريد الكتروني";
            textTw = "Twitter";
            textFb = "Facebook";
            textWa = "Whatsapp";
            textTg = "Telegram";
            textPrint = "طباعة"
            textCp = "نسخ الرابط"
            textCpPopUp = "تم نسخ الرابط إلى الحافظة"
            textNewPost = "نشر تعليق جديد"
        }

        return (
            <div className={`SiteArticleSocialShare1280 ${className}`}>
                {this.shouldShow("tw") && <button title={textTw} className="shareIcon1280 tw" onClick={e => this.handleShareBtnClicked("tw")}></button>}
                {this.shouldShow("fb") && <button title={textFb} className="shareIcon1280 fb" onClick={e => this.handleShareBtnClicked("fb")}></button>}
                {this.shouldShow("wa") && <button title={textWa} className="shareIcon1280 wa" onClick={e => this.handleShareBtnClicked("wa")}></button>}
                {this.shouldShow("tg") && <button title={textTg} className="shareIcon1280 tg" onClick={e => this.handleShareBtnClicked("tg")}></button>}
                {this.shouldShow("print") && <button title={textPrint} className="shareIcon1280 print" onClick={e => this.handleShareBtnClicked("print")}></button>}
                {this.shouldShow("mailto") && <button title={textMail} className="shareIcon1280 mailto" onClick={e => this.handleShareBtnClicked("mailto")}></button>}
                {this.shouldShow("tb") && <button title={textNewPost} className="shareIcon1280 tb" onClick={e => this.handleShareBtnClicked("tb")}></button>}
                {this.shouldShow("copyLink") && <FrontCopyButton classes="shareIcon1280 copyLink" url={typeof window !== "undefined" ? window.location.href : ""} popupText={textCpPopUp} title={analyticsTitle} alt={textCp} />}
            </div>
        )
    }
}